













































































import Vue from 'vue';
import { validationMixin } from 'vuelidate';
import { required, email, numeric } from 'vuelidate/lib/validators';
import Modal from '~/components/common/Modal/Modal.vue';
import BravadoTextInputV3 from '~/components/common/BravadoTextInputV3/BravadoTextInputV3.vue';
import BravadoCheckboxV3 from '~/components/common/BravadoCheckboxV3/BravadoCheckboxV3.vue';
import BravadoButtonV3 from '~/components/common/BravadoButtonV3/BravadoButtonV3.vue';
import BravadoTheme from '~/components/common/BravadoTheme/BravadoTheme.vue';
import CloseIcon from '~/assets/svg/close.vue.svg';

interface EmployerOnboardingModalData {
  form: Form;
  attemptedSubmission: boolean;
  companyLabels: Record<keyof Form, string>;
  successfulSubmitted: boolean;
  isSubmitting: boolean;
}

interface Form {
  fullName: string;
  company: string;
  sizeOfCompany: string;
  numberOfSalesRoles: string;
  sdrRole: boolean;
  aeRole: boolean;
  managementRole: boolean;
  otherRole: boolean;
  email: string;
  formName: string;
  source: string;
  test: boolean;
}

export default Vue.extend({
  name: 'EmployerOnboardingModal',
  components: { BravadoCheckboxV3, BravadoTextInputV3, Modal, BravadoButtonV3, BravadoTheme, CloseIcon },
  mixins: [validationMixin],
  data(): EmployerOnboardingModalData {
    return {
      attemptedSubmission: false,
      successfulSubmitted: false,
      isSubmitting: false,
      form: {
        fullName: '',
        company: '',
        sizeOfCompany: '',
        numberOfSalesRoles: '',
        sdrRole: false,
        aeRole: false,
        managementRole: false,
        otherRole: false,
        email: '',
        formName: 'talent-form',
        source: 'https://bravado.co/lp/talent',
        test: false,
      },
      companyLabels: {
        fullName: 'Full Name',
        company: 'Company',
        sizeOfCompany: 'Size of company',
        numberOfSalesRoles: '# of sales roles',
        sdrRole: 'SDR',
        aeRole: 'AE',
        managementRole: 'Management',
        otherRole: 'Other',
        email: 'Email',
        formName: '',
        source: '',
        test: '',
      },
    };
  },
  validations: {
    form: {
      fullName: {
        required,
      },
      company: {
        required,
      },
      sizeOfCompany: {
        required,
        numeric,
      },
      numberOfSalesRoles: {
        required,
        numeric,
      },
      email: {
        required,
        email,
      },
    },
  },
  computed: {
    isFieldValid(): Record<keyof Form, boolean> {
      const reduceDefaultValue = Object.keys(this.form).reduce((acc, key) => {
        acc[key as keyof Form] = false;
        return acc;
      }, {} as Record<keyof Partial<Form>, boolean>);
      return Object.keys(this.$v.form).reduce((acc, key) => {
        const validation = this.$v.form[key];
        return { ...acc, [key]: !(validation?.$invalid && this.attemptedSubmission) };
      }, reduceDefaultValue);
    },
  },
  methods: {
    errorMessages(field: keyof Form): string {
      const messages = {
        required: `Please provide the ${this.companyLabels[field]}`,
        email: 'Please provide a valid mail',
        numeric: `${this.companyLabels[field]} must be a number.`,
      } as const;

      const validation = this.$v.form[field];

      const validationRule = Object.keys(messages).find(key => validation?.[key] !== undefined && !validation?.[key]);

      return validationRule && this.attemptedSubmission ? messages[validationRule as keyof typeof messages] : '';
    },
    async onSubmit(): Promise<void> {
      this.isSubmitting = true;
      this.attemptedSubmission = true;
      this.$v.form.$touch();
      if (this.$v.form.$invalid) {
        this.isSubmitting = false;
        return;
      }
      const params = new URLSearchParams();
      const fieldsMap: Record<string, keyof Form> = {
        name: 'formName',
        source: 'source',
        test: 'test',
        'fields[FullName]': 'fullName',
        'fields[Company Name 2]': 'company',
        'fields[companySize]': 'sizeOfCompany',
        'fields[Email 2]': 'email',
        'fields[SDR]': 'sdrRole',
        'fields[Other]': 'otherRole',
        'fields[Checkbox 2]': 'aeRole',
        'fields[Checkbox 3]': 'managementRole',
      };
      Object.entries(fieldsMap).forEach(([fieldName, valueKey]) => {
        params.append(fieldName, `${this.form[valueKey]}`);
      });

      const { status } = await this.$axios.post('https://webflow.com/api/v1/form/61b0fad4adf80487ddd39ccb', params);

      if (status === 200) {
        this.successfulSubmitted = true;
      }
      this.isSubmitting = false;
    },
    handleClose() {
      this.$modal.hide(this.$constants.dynamicModals.EMPLOYER_ONBOARDING_MODAL);
    },
  },
});
